@file:OptIn(InternalResourceApi::class)

package chat.amp.tim.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/chat.amp.tim.resources/"

internal val Res.drawable.brand_logo_end: DrawableResource by lazy {
      DrawableResource("drawable:brand_logo_end", setOf(
        ResourceItem(setOf(), "${MD}drawable/brand_logo_end.png", -1, -1),
      ))
    }

internal val Res.drawable.brand_logo_start: DrawableResource by lazy {
      DrawableResource("drawable:brand_logo_start", setOf(
        ResourceItem(setOf(), "${MD}drawable/brand_logo_start.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("brand_logo_end", Res.drawable.brand_logo_end)
  map.put("brand_logo_start", Res.drawable.brand_logo_start)
}
